export const MAIN_PAGE_NAV_LABEL = 'All Sessions';

// MFA Summary Metric Labels
export const SESSIONS_METRIC_LABEL = 'Sessions';
export const SCANS_METRIC_LABEL = 'Scans';
export const CRITICAL_ISSUES_METRIC_LABEL = 'Critical issues';
